import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Row, Col } from 'react-bootstrap';
import { QuestionDescriptionFields, ScaleSelect } from './EvaluationScaleShared';
import { EMOJI_SETS, EMOJI_N_OPTIONS, makeSimpleChoices } from '../EvaluationScaleConfig';

export const EmojiScaleLayout = ({ valuePath, questionChoicesAttributes = [] }) => {
  const { setFieldValue } = useFormikContext();
  const visibleChoices = questionChoicesAttributes.filter(c => !c._destroy);
  const n = visibleChoices.length || 5;
  const emojis = EMOJI_SETS[n] || EMOJI_SETS[5];

  const handleNChange = val => {
    setFieldValue(`${valuePath}[questionChoicesAttributes]`, makeSimpleChoices(parseInt(val, 10)));
  };

  return (
    <div className="mt-3">
      <QuestionDescriptionFields valuePath={valuePath} descriptionPlaceholder="Selecciona un Emoji" />
      <ScaleSelect
        label="N° de Emojis"
        options={EMOJI_N_OPTIONS}
        value={n}
        onChange={handleNChange}
      />
      <Row>
        <Col>
          <p className="text-muted mb-1">
            Respuesta: <span className="eval-scale-preview-hint">(Vista Previa)</span>
          </p>
          <div className="eval-emoji-row">
            {visibleChoices.map((choice, idx) => {
              const realIdx = questionChoicesAttributes.indexOf(choice);
              return (
                <div key={choice.id || choice.position} className="eval-emoji-item">
                  <span className="eval-emoji-icon">{emojis[idx] || '😐'}</span>
                  <Field name={`${valuePath}[questionChoicesAttributes][${realIdx}][label]`}>
                    {({ field }) => (
                      <input
                        {...field}
                        value={field.value || ''}
                        maxLength={25}
                        placeholder={`Opción ${idx + 1}`}
                        className="eval-emoji-label-input"
                      />
                    )}
                  </Field>
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EmojiScaleLayout;
